import React from "react";
import { View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import Skeletons from "../skeleton-components/Skeletons";

const ProfileGamesSkeleton: React.FC = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  return (
    <View
      style={{
        flex: 1,
        width:
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG
            ? "100%"
            : 391,
      }}
    >
      <View
        style={{
          flex: 1,
          padding: 18,
          borderColor: AppColors.gray_828282,
          borderWidth: 0.8,
          borderRadius: 8,
          backgroundColor: AppColors.black_191919,
        }}
      >
        {/* Header */}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Skeletons width="150px" height={24} style={{ borderRadius: 4 }} />
          <Skeletons
            width="32px"
            height="32px"
            circle
            style={{ borderRadius: 16 }}
          />
        </View>

        {/* Separator */}
        <Skeletons
          width="100%"
          height={1}
          style={{ marginTop: 12, marginBottom: 12, borderRadius: 4 }}
        />

        {/* Game List */}
        <View style={{ maxHeight: 191 }}>
          {Array(3)
            .fill(null)
            .map((_, index) => (
              <View
                key={index}
                style={{
                  flexDirection: "row",
                  gap: 5,
                  alignItems: "center",
                  padding: 10,
                }}
              >
                <Skeletons
                  width="48px"
                  height="48px"
                  style={{ borderRadius: 12 }}
                />
                <Skeletons
                  width="100px"
                  height={18}
                  style={{ borderRadius: 4 }}
                />
              </View>
            ))}
        </View>
      </View>
    </View>
  );
};

export default ProfileGamesSkeleton;

const useStyles = CreateResponsiveStyle(
  {},
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
